/* Gato product gallery V2 — portrait-first.
   Copy of gato-product-gallery.js. Each slide is sized from its own aspect
   ratio instead of an assumed 3:2, so portrait and landscape both display
   correctly in one gallery. Loaded only by product.v2 templates. */
(function () {
  'use strict';

  var MIN_LEFT      = 8;
  var THUMB_W       = 90;
  var THUMB_H       = 120; // portrait 3:4 thumbs
  var THUMB_GAP     = 6;
  var THUMB_STEP    = THUMB_H + THUMB_GAP; // 126px per slot
  var FILM_VISIBLE  = 5;  // slots shown in the desktop thumb window
  var FILM_RENDER   = 7;  // rendered items (1 extra each side for slide-in)
  var FILM_CENTER   = 3;  // index of current item in rendered array (0-based)
  var FALLBACK_RATIO = 3 / 2; // only used when a slide has no known dimensions
  var RAIL_RATIO    = 3 / 2;  // landscape reference — fixes the thumbnail rail
  var LEFT_FRAC     = 0.09;   // photo's left edge, as a fraction of the viewport
  var MAX_WIDTH_FRAC = 0.62;  // cap on photo width, so landscape cannot dominate
  var isDesktop     = window.matchMedia('(hover: hover) and (min-width: 750px)').matches;

  // ── Read image list from Liquid JSON block ────────────────────────
  var dataEl = document.getElementById('gato-gallery-data');
  if (!dataEl) return;
  var images;
  try { images = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!images || images.length === 0) return;

  var total   = images.length;
  var current = 0;

  // ── Mobile filmstrip constants ────────────────────────────────────
  var FILM_W    = 30;
  var FILM_H    = 40; // portrait 3:4
  var FILM_GAP  = 5;
  var FILM_STEP_M = FILM_W + FILM_GAP;

  // ── DOM refs ──────────────────────────────────────────────────────
  var group          = document.getElementById('gatoGalleryGroup');
  var mainWrap       = document.getElementById('gatoGalleryMain');
  var mainImg        = document.getElementById('gatoMainImg');
  var thumbNavEl     = document.querySelector('.gato-gallery__thumb-nav');
  var thumbsEl       = document.getElementById('gatoGalleryThumbs');
  var thumbPrev      = document.getElementById('gatoThumbPrev');
  var thumbNext      = document.getElementById('gatoThumbNext');
  var filmstripEl    = document.getElementById('gatoFilmstrip');
  var filmstripTrack = document.getElementById('gatoFilmstripTrack');
  var hiresLoader    = document.getElementById('gatoHiresLoader');
  var arrowsEl       = document.getElementById('gatoGalleryArrows');
  var arrowPrev      = arrowsEl && arrowsEl.querySelector('.gato-gallery__arrow-btn--prev');
  var arrowNext      = arrowsEl && arrowsEl.querySelector('.gato-gallery__arrow-btn--next');
  var arrowIndex     = document.getElementById('gatoArrowIndex');
  var zoomCursor     = document.getElementById('gatoZoomCursor');
  var thumbTrack     = null; // desktop: sliding inner container
  var dotsEl         = null; // desktop: dot indicators

  if (!group || !mainWrap || !mainImg) return;

  // ── Aspect ratio of a given slide ─────────────────────────────────
  // Prefers the intrinsic size embedded by Liquid, so the slot is correct
  // before the image loads. Falls back to the loaded image, then to 3:2.
  function ratioFor(idx) {
    var d = images[((idx % total) + total) % total];
    if (d && d.w > 0 && d.h > 0) return d.w / d.h;
    if (idx === current && mainImg.naturalWidth && mainImg.naturalHeight) {
      return mainImg.naturalWidth / mainImg.naturalHeight;
    }
    return FALLBACK_RATIO;
  }

  // ── Width of the photo slot for a slide ───────────────────────────
  // Portrait fills the full band height; landscape is capped by width, so it
  // renders shorter than portrait rather than sprawling across the banner.
  function widthForRatio(r) {
    var maxW = Math.min(window.innerWidth * MAX_WIDTH_FRAC,
                        window.innerWidth - MIN_LEFT * 2);
    return Math.round(Math.min(mainWrap.offsetHeight * r, maxW));
  }

  // Landscape reference — the widest any photo may be, and the anchor for the
  // shared right edge.
  function refWidth() {
    return widthForRatio(RAIL_RATIO);
  }

  function baseLeft() {
    return Math.round(Math.max(MIN_LEFT, window.innerWidth * LEFT_FRAC));
  }

  // Right edge of the landscape footprint — where the thumbnail column starts.
  function refRight() {
    return baseLeft() + refWidth();
  }

  // Centre line of the landscape footprint. Every slide is centred on it, so a
  // portrait photo sits directly under a landscape one.
  function refCentre() {
    return baseLeft() + refWidth() / 2;
  }

  function photoWidthFor(idx) {
    return Math.min(widthForRatio(ratioFor(idx)), refWidth());
  }


  // ── Size the slot to the current slide, left edge fixed ───────────
  // ── Centre the slot on the landscape centre line ──────────────────
  // The photo is centred, so portrait and landscape share a centre. The thumb
  // column is therefore taken out of flow and pinned in viewport space
  // (--gato-rail-x), otherwise it would drift with the slot width.
  function reposition() {
    if (!isDesktop) {
      group.style.marginLeft = '';
      mainWrap.style.width = '';
      group.style.removeProperty('--gato-rail-x');
      return;
    }
    var w = photoWidthFor(current);
    mainWrap.style.width   = w + 'px';
    group.style.marginLeft = Math.round(refCentre() - w / 2) + 'px';
    group.style.setProperty('--gato-rail-x', (refRight() + THUMB_GAP) + 'px');
  }

  // ── Show thumbs or arrows depending on available space ───────────
  function checkLayout() {
    if (total <= 1) return;
    if (!isDesktop) {
      if (thumbNavEl) thumbNavEl.style.display = 'none';
      if (arrowsEl)   arrowsEl.classList.add('is-visible');
      return;
    }
    var rightEdge  = refRight() + THUMB_GAP + THUMB_W;
    var thumbsFit  = rightEdge <= (window.innerWidth - MIN_LEFT);

    if (thumbsFit) {
      if (thumbNavEl) thumbNavEl.style.display = '';
      if (arrowsEl)   arrowsEl.classList.remove('is-visible');
    } else {
      if (thumbNavEl) thumbNavEl.style.display = 'none';
      if (arrowsEl)   arrowsEl.classList.add('is-visible');
    }
  }

  // ── Preload all thumbnail images at init ──────────────────────────
  function preloadThumbs() {
    for (var i = 0; i < total; i++) {
      var img = new Image();
      img.src = images[i].thumb;
    }
  }

  function preloadFull(idx) {
    var img = new Image();
    img.src = images[((idx % total) + total) % total].src;
  }

  function preloadAdjacent(idx) {
    preloadFull(idx + 1);
    preloadFull(idx - 1);
  }

  // ── Preload all full images sequentially (desktop) ────────────────
  function preloadAllFull() {
    var i = 1;
    function next() {
      if (i >= total) return;
      var img = new Image();
      img.onload = img.onerror = next;
      img.src = images[i % total].src;
      i++;
    }
    next();
  }

  // ── Desktop thumbnail strip ───────────────────────────────────────
  function buildThumbs(idx) {
    if (!thumbTrack) return;
    thumbTrack.style.visibility = 'hidden';
    while (thumbTrack.firstChild) thumbTrack.removeChild(thumbTrack.firstChild);
    if (total <= 1) { thumbTrack.style.visibility = ''; return; }

    if (total <= 3) {
      // Static mode: show all images, mark current
      for (var i = 0; i < total; i++) {
        var data      = images[i];
        var isCurrent = (i === idx);

        var thumbDiv = document.createElement('div');
        thumbDiv.className = 'gato-gallery__thumb' + (isCurrent ? ' is-current' : '');
        thumbDiv.setAttribute('data-index', String(i));

        var thumbImg = document.createElement('img');
        thumbImg.src    = data.thumb;
        thumbImg.alt    = data.alt || '';
        thumbImg.width  = THUMB_W;
        thumbImg.height = THUMB_H;

        thumbDiv.appendChild(thumbImg);
        if (!isCurrent) thumbDiv.addEventListener('click', onThumbClick);
        thumbTrack.appendChild(thumbDiv);

        (function (el, img) {
          function show() { el.style.transition = 'none'; el.style.opacity = '1'; el.classList.add('is-loaded'); }
          if (img.complete && img.naturalWidth) show();
          else img.addEventListener('load', show, { once: true });
        })(thumbDiv, thumbImg);
      }
      thumbTrack.style.transition = 'none';
      thumbTrack.style.transform  = 'translateY(0)';
      requestAnimationFrame(function() { thumbTrack.style.visibility = ''; });
      return;
    }

    // Carousel mode: 7 items centred on current
    for (var i = 0; i < FILM_RENDER; i++) {
      var imgIdx    = ((idx - FILM_CENTER + i) % total + total) % total;
      var data      = images[imgIdx];
      var isCurrent = (i === FILM_CENTER);

      var thumbDiv = document.createElement('div');
      thumbDiv.className = 'gato-gallery__thumb' + (isCurrent ? ' is-current' : '');
      thumbDiv.setAttribute('data-index', String(imgIdx));

      var thumbImg = document.createElement('img');
      thumbImg.src    = data.thumb;
      thumbImg.alt    = data.alt || '';
      thumbImg.width  = THUMB_W;
      thumbImg.height = THUMB_H;

      thumbDiv.appendChild(thumbImg);
      if (!isCurrent) thumbDiv.addEventListener('click', onThumbClick);
      thumbTrack.appendChild(thumbDiv);

      (function (el, img) {
        function show() { el.style.transition = 'none'; el.style.opacity = '1'; el.classList.add('is-loaded'); }
        if (img.complete && img.naturalWidth) show();
        else img.addEventListener('load', show, { once: true });
      })(thumbDiv, thumbImg);
    }

    thumbTrack.style.transition = 'none';
    thumbTrack.style.transform  = 'translateY(-' + THUMB_STEP + 'px)';
    requestAnimationFrame(function() { thumbTrack.style.visibility = ''; });
  }

  // ── Dot indicators ────────────────────────────────────────────────
  function buildDots() {
    if (!isDesktop || total <= 1) return;
    dotsEl = document.createElement('div');
    dotsEl.className = 'gato-gallery__dots';
    for (var i = 0; i < total; i++) {
      var dot = document.createElement('span');
      dot.className = 'gato-gallery__dot';
      dotsEl.appendChild(dot);
    }
    if (thumbNavEl && thumbNavEl.parentNode) {
      thumbNavEl.parentNode.insertBefore(dotsEl, thumbNavEl.nextSibling);
    }
    updateDots(0);
  }

  function updateDots(idx) {
    if (!dotsEl) return;
    var dots = dotsEl.children;
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', i === idx);
    }
  }

  function onThumbClick() {
    var idx = parseInt(this.getAttribute('data-index'), 10);
    goTo(idx);
  }

  // ── Mobile filmstrip ──────────────────────────────────────────────
  function buildFilmstrip() {
    if (!filmstripTrack) return;
    while (filmstripTrack.firstChild) filmstripTrack.removeChild(filmstripTrack.firstChild);
    for (var i = 0; i < total; i++) {
      var item = document.createElement('div');
      item.className = 'gato-gallery__filmstrip-thumb' + (i === 0 ? ' is-current' : '');
      var img = document.createElement('img');
      img.src    = images[i].thumb;
      img.alt    = images[i].alt || '';
      img.width  = FILM_W;
      img.height = FILM_H;
      item.appendChild(img);
      filmstripTrack.appendChild(item);
    }
    positionFilmstrip(0, false, 0);
  }

  function positionFilmstrip(idx, animate, dx) {
    if (!filmstripEl || !filmstripTrack) return;
    var cw     = filmstripEl.offsetWidth;
    var offset = cw / 2 - FILM_W / 2 - idx * FILM_STEP_M + (dx || 0) / mainWrap.offsetWidth * FILM_STEP_M;
    filmstripTrack.style.transition = animate
      ? 'transform 260ms cubic-bezier(0.25,0.46,0.45,0.94)'
      : 'none';
    filmstripTrack.style.transform = 'translateX(' + offset + 'px)';
    var thumbs = filmstripTrack.children;
    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].classList.toggle('is-current', i === idx);
    }
  }

  // ── Arrow index label ─────────────────────────────────────────────
  function updateArrowIndex() {
    if (arrowIndex) arrowIndex.textContent = (current + 1) + ' / ' + total;
  }

  // ── Navigate ──────────────────────────────────────────────────────
  var isSliding = false;

  function goTo(idx) {
    idx = ((idx % total) + total) % total;
    if (idx === current) return;
    if (mobileZoomed) zoomOut(false);

    if (isDesktop) {
      // Desktop: slide filmstrip track
      if (isSliding) return;
      var prevIdx   = current;
      current       = idx;
      var diff      = idx - prevIdx;
      if (diff >  total / 2) diff -= total;
      if (diff < -total / 2) diff += total;
      var steps     = Math.abs(diff);
      var goingNext = diff > 0;

      var tempImg = new Image();
      tempImg.onload = function () {
        mainImg.style.opacity = '0';
        // Resize the slot now, while the photo is fading out — the width
        // transition then runs under the crossfade instead of snapping after it.
        reposition();
        checkLayout();
        mainImg.addEventListener('load', function () {
          mainImg.style.opacity = '1';
        }, { once: true });
        mainImg.src = images[idx].src;
        mainImg.alt = images[idx].alt || '';
        updateArrowIndex();
        preloadFull(idx + 1);
      };
      tempImg.src = images[idx].src;

      if (!thumbTrack || total <= 1) return;

      if (total <= 3) {
        buildThumbs(idx);
        updateDots(idx);
        return;
      }

      isSliding = true;
      var targetY = goingNext
        ? -(THUMB_STEP + steps * THUMB_STEP)
        :  (steps * THUMB_STEP - THUMB_STEP);
      thumbTrack.style.transition = 'transform ' + (0.22 + steps * 0.06) + 's cubic-bezier(0.4, 0, 0.2, 1)';
      thumbTrack.style.transform  = 'translateY(' + targetY + 'px)';
      thumbTrack.addEventListener('transitionend', function () {
        isSliding = false;
        buildThumbs(idx);
        updateDots(idx);
      }, { once: true });

    } else {
      // Mobile: crossfade + filmstrip
      current = idx;
      var nextSrc = images[idx].src;
      var nextAlt = images[idx].alt || '';
      var tempImg2 = new Image();
      tempImg2.onload = function () {
        mainImg.style.opacity = '0';
        mainImg.addEventListener('load', function () {
          mainImg.style.opacity = '1';
        }, { once: true });
        mainImg.src = nextSrc;
        mainImg.alt = nextAlt;
        updateArrowIndex();
        positionFilmstrip(idx, true, 0);
        preloadAdjacent(idx);
      };
      tempImg2.src = nextSrc;
    }
  }

  // ── Desktop zoom ──────────────────────────────────────────────────
  var zoomed = false;

  function enableZoom() {
    if (!isDesktop) return;
    mainWrap.addEventListener('click', toggleZoom);
    mainWrap.addEventListener('mousemove', onZoomMove);
    mainWrap.addEventListener('mouseleave', function () {
      if (zoomed) toggleZoom();
    });
  }

  function loadZoomImage() {
    var zoomSrc = images[current].zoom;
    if (!zoomSrc || mainImg.src === zoomSrc) return;
    if (hiresLoader) hiresLoader.classList.add('is-loading');
    var preload = new Image();
    preload.onload = function () {
      if (hiresLoader) hiresLoader.classList.remove('is-loading');
      if (zoomed) mainImg.src = zoomSrc;
    };
    preload.onerror = function () {
      if (hiresLoader) hiresLoader.classList.remove('is-loading');
    };
    preload.src = zoomSrc;
  }

  function toggleZoom() {
    zoomed = !zoomed;
    mainWrap.classList.toggle('zoom-active', zoomed);
    if (zoomed) {
      loadZoomImage();
    } else {
      if (hiresLoader) hiresLoader.classList.remove('is-loading');
      mainImg.src = images[current].src;
      mainImg.style.transformOrigin = '';
    }
  }

  function onZoomMove(e) {
    if (!zoomed) return;
    var r  = mainWrap.getBoundingClientRect();
    var px = ((e.clientX - r.left) / r.width)  * 100;
    var py = ((e.clientY - r.top)  / r.height) * 100;
    mainImg.style.transformOrigin = px + '% ' + py + '%';
    if (zoomCursor) {
      zoomCursor.style.left = (e.clientX - r.left) + 'px';
      zoomCursor.style.top  = (e.clientY - r.top)  + 'px';
    }
  }

  // ── Arrow / thumb-nav buttons ─────────────────────────────────────
  if (arrowPrev) arrowPrev.addEventListener('click', function () { goTo(current - 1); });
  if (arrowNext) arrowNext.addEventListener('click', function () { goTo(current + 1); });
  if (thumbPrev) thumbPrev.addEventListener('click', function () { goTo(current - 1); });
  if (thumbNext) thumbNext.addEventListener('click', function () { goTo(current + 1); });

  // ── Mobile zoom state ─────────────────────────────────────────────
  var mobileZoomed = false;
  var zoomScale    = 4;
  var zoomTx = 0, zoomTy = 0;
  var zoomPhotoW = 0, zoomPhotoH = 0;
  var panBaseTx = 0, panBaseTy = 0;
  var panStartX = 0, panStartY = 0;

  function getPhotoRect() {
    var pad    = 12;
    var innerW = mainWrap.offsetWidth  - pad * 2;
    var innerH = mainWrap.offsetHeight - pad * 2;
    var IW     = mainImg.naturalWidth  || innerW;
    var IH     = mainImg.naturalHeight || innerH;
    var s      = Math.min(innerW / IW, innerH / IH);
    var rW     = IW * s;
    var rH     = IH * s;
    return { x: pad + (innerW - rW) / 2, y: pad + (innerH - rH) / 2, w: rW, h: rH };
  }

  function applyZoom(tx, ty, animate) {
    tx = Math.max(-zoomPhotoW * (zoomScale - 1), Math.min(0, tx));
    ty = Math.max(-zoomPhotoH * (zoomScale - 1), Math.min(0, ty));
    zoomTx = tx; zoomTy = ty;
    mainImg.style.transition      = animate ? 'transform 0.28s ease' : 'none';
    mainImg.style.transformOrigin = '0 0';
    mainImg.style.transform       = 'translate(' + tx + 'px,' + ty + 'px) scale(' + zoomScale + ')';
  }

  function zoomIn() {
    var r      = getPhotoRect();
    zoomPhotoW = r.w;
    zoomPhotoH = r.h;
    mainImg.style.objectFit = 'unset';
    mainImg.style.position  = 'absolute';
    mainImg.style.width     = r.w + 'px';
    mainImg.style.height    = r.h + 'px';
    mainImg.style.left      = r.x + 'px';
    mainImg.style.top       = r.y + 'px';
    mobileZoomed = true;
    mainWrap.classList.add('is-zoomed');
    applyZoom(r.w * (1 - zoomScale) / 2, r.h * (1 - zoomScale) / 2, true);
    setTimeout(function () { loadZoomSrc(current); }, 300);
  }

  function loadZoomSrc(idx) {
    var zoomSrc = images[idx] && images[idx].zoom;
    if (!zoomSrc || mainImg.getAttribute('src') === zoomSrc) return;
    if (hiresLoader) hiresLoader.classList.add('is-loading');
    var hi = new Image();
    hi.onload = function () {
      if (hiresLoader) hiresLoader.classList.remove('is-loading');
      if (mobileZoomed && current === idx) mainImg.src = zoomSrc;
    };
    hi.onerror = function () {
      if (hiresLoader) hiresLoader.classList.remove('is-loading');
    };
    hi.src = zoomSrc;
  }

  function zoomOut(animate) {
    mobileZoomed = false;
    mainWrap.classList.remove('is-zoomed');
    if (hiresLoader) hiresLoader.classList.remove('is-loading');
    mainImg.style.objectFit       = '';
    mainImg.style.position        = '';
    mainImg.style.width           = '';
    mainImg.style.height          = '';
    mainImg.style.left            = '';
    mainImg.style.top             = '';
    mainImg.style.transformOrigin = '';
    mainImg.style.transform       = '';
    mainImg.style.transition      = animate ? 'transform 0.25s ease' : '';
    zoomTx = 0; zoomTy = 0; zoomPhotoW = 0; zoomPhotoH = 0;
    var normalSrc = images[current] && images[current].src;
    if (normalSrc && mainImg.getAttribute('src') !== normalSrc) mainImg.src = normalSrc;
  }

  // ── Touch swipe ───────────────────────────────────────────────────
  var touchStartX    = 0;
  var touchStartY    = 0;
  var touchDirLocked = false;
  var dragActive     = false;
  var dragImg        = null;
  var dragDir        = 0;

  var swipeTarget = group.closest('.gato-gallery') || mainWrap;

  function cancelDrag() {
    if (dragImg && dragImg.parentNode) dragImg.parentNode.removeChild(dragImg);
    dragImg        = null;
    dragActive     = false;
    touchDirLocked = false;
    dragDir        = 0;
    if (!mobileZoomed) {
      mainImg.style.transition = '';
      mainImg.style.transform  = '';
    }
  }

  swipeTarget.addEventListener('touchstart', function (e) {
    var t = e.touches[0];
    touchStartX = t.clientX;
    touchStartY = t.clientY;

    if (mobileZoomed) {
      panStartX = t.clientX;
      panStartY = t.clientY;
      panBaseTx = zoomTx;
      panBaseTy = zoomTy;
      return;
    }

    if (total > 1) {
      cancelDrag();
      preloadAdjacent(current);
    }
  }, { passive: true });

  swipeTarget.addEventListener('touchmove', function (e) {
    var t  = e.touches[0];
    var dx = t.clientX - touchStartX;
    var dy = t.clientY - touchStartY;

    if (mobileZoomed) {
      e.preventDefault();
      applyZoom(panBaseTx + (t.clientX - panStartX), panBaseTy + (t.clientY - panStartY), false);
      return;
    }

    if (total <= 1) return;

    if (!touchDirLocked) {
      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
      if (Math.abs(dy) >= Math.abs(dx)) return;
      touchDirLocked = true;
      dragActive     = true;
      dragDir        = dx < 0 ? -1 : 1;

      var nextIdx = dx < 0 ? (current + 1) % total : (current - 1 + total) % total;
      dragImg = document.createElement('img');
      dragImg.src  = images[nextIdx].src;
      dragImg.alt  = images[nextIdx].alt || '';
      dragImg._idx = nextIdx;
      dragImg.style.cssText =
        'position:absolute;inset:0;width:100%;height:100%;' +
        'object-fit:contain;will-change:transform;' +
        'transform:translateX(' + (-dragDir * 100) + '%)';
      mainWrap.appendChild(dragImg);
      mainImg.style.willChange = 'transform';
    }

    if (!dragActive) return;

    var pct = (dx / mainWrap.offsetWidth) * 100;
    mainImg.style.transition = 'none';
    mainImg.style.transform  = 'translateX(' + pct + '%)';
    dragImg.style.transition = 'none';
    dragImg.style.transform  = 'translateX(' + (-dragDir * 100 + pct) + '%)';
    positionFilmstrip(current, false, dx);
  }, { passive: false });

  function onSwipeEnd(e) {
    var t   = e.changedTouches[0];
    var dx  = t.clientX - touchStartX;
    var dy  = t.clientY - touchStartY;
    var isTap = Math.abs(dx) < 8 && Math.abs(dy) < 8;

    if (mobileZoomed) {
      if (isTap) zoomOut(true);
      return;
    }

    if (isTap) {
      zoomIn();
      return;
    }

    if (!dragActive || !dragImg) { cancelDrag(); return; }

    var nextIdx   = dragImg._idx;
    var threshold = mainWrap.offsetWidth * 0.12;
    var committed = Math.abs(dx) >= threshold;
    var dur       = committed ? 260 : 200;

    mainImg.style.transition = 'transform ' + dur + 'ms cubic-bezier(0.25,0.46,0.45,0.94)';
    dragImg.style.transition = 'transform ' + dur + 'ms cubic-bezier(0.25,0.46,0.45,0.94)';

    if (committed) {
      mainImg.style.transform = 'translateX(' + (dragDir * 100) + '%)';
      dragImg.style.transform = 'translateX(0%)';
      positionFilmstrip(nextIdx, true, 0);
    } else {
      mainImg.style.transform = 'translateX(0%)';
      dragImg.style.transform = 'translateX(' + (-dragDir * 100) + '%)';
      positionFilmstrip(current, true, 0);
    }

    var snap = dragImg;
    dragImg = null; dragActive = false; touchDirLocked = false;

    setTimeout(function () {
      if (committed) {
        current     = nextIdx;
        mainImg.src = images[nextIdx].src;
        mainImg.alt = images[nextIdx].alt || '';
        updateArrowIndex();
        preloadAdjacent(nextIdx);
      }
      mainImg.style.transition = '';
      mainImg.style.transform  = '';
      mainImg.style.willChange = '';
      if (snap && snap.parentNode) snap.parentNode.removeChild(snap);
    }, dur);
  }

  swipeTarget.addEventListener('touchend',    onSwipeEnd, { passive: true });
  swipeTarget.addEventListener('touchcancel', function () { if (!mobileZoomed) cancelDrag(); }, { passive: true });

  // ── Initialise ────────────────────────────────────────────────────
  function init() {
    group.style.marginLeft = MIN_LEFT + 'px';
    if (!mainImg.alt) mainImg.alt = images[0].alt || '';

    // Desktop: create sliding track inside thumbsEl
    if (isDesktop && thumbsEl) {
      thumbTrack = document.createElement('div');
      thumbTrack.className = 'gato-gallery__thumb-track';
      thumbsEl.appendChild(thumbTrack);
    }

    function afterFirstLoad() {
      mainImg.style.opacity = '1';
      reposition();
      checkLayout();
      if (isDesktop) preloadAllFull();
    }

    if (mainImg.complete && mainImg.naturalWidth) {
      afterFirstLoad();
    } else {
      mainImg.addEventListener('load', afterFirstLoad, { once: true });
    }

    if (isDesktop && total <= 3) {
      var galleryEl = group.closest('.gato-gallery');
      if (galleryEl) galleryEl.classList.add('gato-gallery--few');
    }

    preloadThumbs();
    if (isDesktop) buildThumbs(0);
    buildFilmstrip();
    updateArrowIndex();
    buildDots();
    enableZoom();

    window.addEventListener('resize', function () {
      reposition();
      checkLayout();
    });
  }

  // ── 2-column product info layout ──────────────────────────────────
  function buildTwoCol() {
    var container = document.querySelector('.product__info-container');
    if (!container) return;
    if (!container.querySelector('.product__description')) return;

    var wrapper = document.querySelector('.product__info-wrapper');
    if (wrapper) {
      wrapper.style.cssText = 'max-width:100%!important;width:100%!important;padding:0!important;float:none!important;';
    }
    var product = document.querySelector('.product');
    if (product) {
      product.style.cssText = 'display:block!important;max-width:100%!important;';
    }
    var productInfo = document.querySelector('product-info');
    if (productInfo) {
      productInfo.style.cssText = 'display:block;width:100%;max-width:100%;';
    }

    var leftCol  = document.createElement('div');
    leftCol.className  = 'gato-info-left';
    var rightCol = document.createElement('div');
    rightCol.className = 'gato-info-right';

    Array.from(container.children).forEach(function (child) {
      if (child.classList && child.classList.contains('product__description')) {
        rightCol.appendChild(child);
      } else {
        leftCol.appendChild(child);
      }
    });

    var twoCol = document.createElement('div');
    twoCol.className = 'gato-info-2col';
    twoCol.appendChild(leftCol);
    twoCol.appendChild(rightCol);
    container.appendChild(twoCol);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); buildTwoCol(); });
  } else {
    init();
    buildTwoCol();
  }

})();
